import { urlCatalog, urlSvg } from '../../../../server/utils/urlConstants';
import {
  urlCeHome,
  routeTheGrapefulClub,
} from '../../../../server/utils/routeConstants';

interface Link {
  text: string;
  url: string;
  isOutbound?: boolean;
}

export const socialMediaLinks = [
  {
    url: 'https://www.facebook.com/onehopewine/',
    iconUrl: `${urlSvg}facebook.svg`,
    imgAlt: 'facebook icon',
  },
  {
    url: 'https://www.instagram.com/onehope/',
    iconUrl: `${urlSvg}instagram.svg`,
    imgAlt: 'instagram icon',
  },
  {
    url: 'https://twitter.com/onehopewine',
    iconUrl: `${urlSvg}twitter.svg`,
    imgAlt: 'twitter icon',
  },
  {
    url: 'https://www.youtube.com/channel/UCsd0Z2BGEs9oiHOp5LpLLIQ',
    iconUrl: `${urlSvg}youtube.svg`,
    imgAlt: 'youtube icon',
  },
];

export const shopLinks: Array<Link> = [
  {
    text: 'Wine',
    url: '/shop/wine/wine',
  },
  {
    text: 'Gifts',
    url: '/shop/gifts/gift',
  },
  {
    text: 'Perks',
    url: `/${routeTheGrapefulClub}`,
  },
  {
    text: 'Corporate Gifting',
    url: `/corporate`,
  },
  {
    text: 'Weddings & Events',
    url: `/weddings`,
  },
];

export const quickLinks: Array<Link> = [
  {
    text: 'FAQ',
    url: '/faq#faq',
  },
  {
    text: 'Shipping',
    url: '/faq#shipping',
  },
  {
    text: 'Returns',
    url: '/faq#returns',
  },
  {
    text: 'Careers',
    url: 'http://onehope.applytojob.com/apply',
    isOutbound: true,
  },
  {
    text: 'Contact Us',
    url: '/faq#contact',
  },
];

export const aboutLinks: Array<Link> = [
  {
    text: 'Our Story',
    url: '/about-us',
  },
  {
    text: 'Our Impact',
    url: '/impact',
  },
  {
    text: 'Winemaking',
    url: '/winemaking',
  },
  {
    text: 'Vineyard',
    url: '/winemaking',
  },
  {
    text: 'Estate 8',
    url: 'https://www.estate8.com/',
  },
  // request to remove foundation link - 6/23/20
  // {
  //   text: 'Foundation',
  //   url: 'http://www.onehopefoundation.org',
  //   isOutbound: true,
  // },
  // {
  //   text: 'Brand Resources',
  //   url:
  //     'https://drive.google.com/drive/folders/1hY0eWvwepP7x1-11gPhKJH0FeFVRYyry?usp=sharing',
  //   isOutbound: true,
  // },
  {
    text: 'Blog',
    url: 'https://www.onehopewine.com/blog',
    isOutbound: true,
  },
  {
    text: 'Catalog',
    url: `${urlCatalog}ONEHOPE-Wine_Hope-At-Home-Catalog-Summer-2021.pdf`,
    isOutbound: true,
  },
];

export const viaLinks: Array<Link> = [
  {
    text: 'Host a Tasting',
    url: '/host',
  },
  {
    text: 'Become a Cause Entrepreneur',
    url: '/join',
  },
  {
    text: 'CE Dashboard',
    url: urlCeHome,
  },
];
